import gql from 'graphql-tag';

const CREATE_SYSTEM_ALERT = gql`
  mutation CreateSystemAlert($data: SystemAlertCreateInput!) {
    createSystemAlert(data: $data) {
      id
      type
      message
      link
      linkText
      dismissible
      startDate
      endDate
      priority
      active
      createdAt
    }
  }
`;

export default CREATE_SYSTEM_ALERT;
